
import React from 'react';

import { Link } from 'react-router-dom';

function StandardAIROI() {
  return (
    <>
      
      <div className="max-w-4xl mx-auto py-12 px-6">
        <div className="border-b border-gray-200 pb-6 mb-8">
          <div className="flex items-center gap-3 mb-2">
            <span className="bg-[#2F80ED] text-white px-2 py-1 text-xs font-mono font-bold">AI-ROI-1.0</span>
            <span className="text-gray-500 text-sm uppercase tracking-wide">Active</span>
          </div>
          <h1 className="text-3xl font-bold text-[#102A43]">Responsibility Domain Mapping</h1>
        </div>

        <div className="bg-blue-50 border-l-4 border-[#2F80ED] p-6 mb-8">
          <h3 className="text-[#2F80ED] font-bold text-sm tracking-wide uppercase mb-2">ASSESS YOUR READINESS</h3>
          <p className="text-blue-800 text-sm mb-4">Not sure if your organization aligns with this standard? Get your free AI Accountability Score — a six-question assessment that maps your governance posture across all AASC standards.</p>
          <Link to="/assessment/form" className="inline-block bg-[#2F80ED] text-white font-bold px-6 py-2 rounded-sm hover:bg-[#2563eb]">Get Your Free Score</Link>
        </div>

        <section className="mb-8">
          <h2 className="text-lg font-bold text-[#102A43] mb-2 border-l-4 border-gray-400 pl-3">Purpose Statement</h2>
          <p className="text-gray-800 text-sm">To explicitly define the operational boundaries of the AI system. AASC Accountability Declaration requires documented alignment with AI-ROI-1.0 prior to production deployment. This standard is foundational for the AASC Accountability Declaration.</p>
        </section>
        <section className="mb-8">
           <h2 className="text-lg font-bold text-[#102A43] mb-2 border-l-4 border-gray-400 pl-3">Requirements</h2>
           <ul className="list-disc pl-5 text-sm text-[#64748B] space-y-2">
             <li>Domain Definition of intended operations.</li>
             <li>Control Boundaries and limits of authority.</li>
             <li>Responsibility Assignment for external domains.</li>
             <li>Boundary Documentation and Client Disclosure.</li>
           </ul>
        </section>

        <div className="bg-[#2F80ED] p-8 rounded-sm text-center mt-12 mb-8">
          <p className="text-white text-lg mb-6">Ready to document your organization's alignment with AASC standards? Start with the AI Accountability Documentation System.</p>
          <Link to="/documentation-system" className="inline-block bg-white text-[#102A43] font-bold px-8 py-3 rounded-sm hover:bg-gray-100">Get the Documentation System — $97</Link>
        </div>
      </div>
    </>
  );
}
export default StandardAIROI;
